<template>
  <Fragment>
    <template v-for="item in node.data.base_event_files">
      <div
        :key="item.id"
        class="file w-inline-block"
      >
        <div class="file__dot" />
        <div class="text-sm mod--file">
          <a
            :href="item.raw_file.url"
            :download="item.name"
            class="LKRoadmapsFeedCardFiles__file-name"
            target="_blank"
            v-text="item.name"
          />
        </div>
      </div>
    </template>

    <template v-for="item in node.children">
      <div
        :key="item.data.id"
        class="file w-inline-block"
      >
        <div class="file__dot" />
        <div class="text-sm mod--file">
          <a
            :href="item.data.raw_file.url"
            :download="item.data.name"
            class="LKRoadmapsFeedCardFiles__file-name"
            target="_blank"
            v-text="item.data.name"
          />

          <IconClose
            v-if="hasRemoveFile && item.data.id"
            class="LKRoadmapsFeedCardFiles__icon-close"
            @click.native="$emit('remove-file', node, item)"
          />
        </div>
      </div>
    </template>

    <div
      v-if="!node.children.length"
      class="text-md"
      v-text="'Список пуст'"
    />

    <LKRoadmapsFeedCardFileBottom
      v-if="hasAddFiles"
      :node="node"
      @change="$emit('add-files', node, $event)"
    />
  </Fragment>
</template>

<script>
import { rootMapper } from '@/store/modules/root'
import { RoadmapEventStatuses } from '@/typings/api/RoadmapEvent'

import { Fragment } from 'vue-fragment'
import IconClose from '@/components/lk/icons/LKIconClose.vue'
import LKRoadmapsFeedCardFileBottom from './LKRoadmapsFeedCardFileBottom.vue'


export default {
  name: 'LKRoadmapsFeedCardFiles',
  inject: [
    'isAdresat',
    'isCurator',
    'isCoordinator',
  ],
  components: {
    Fragment,
    IconClose,
    LKRoadmapsFeedCardFileBottom,
  },
  inheritAttrs: false,
  props: {
    node: {
      type: Object,
      required: true,
    },
    readonly: Boolean,
  },
  computed: {
    ...rootMapper.mapGetters(['profile']),

    hasRemoveFile() {
      const { data } = this.node
      const { inProgress, needsWork } = RoadmapEventStatuses

      return (

        this.profile.is_superuser
        || (
          [inProgress, needsWork].includes(data.status)
          && !this.readonly
          && this.isAdresat
        )
      )
    },
    hasAddFiles() {
      return (
        this.profile.is_superuser
        || (
          this.node.data.status !== RoadmapEventStatuses.done
          && !this.readonly
          && this.isAdresat
        )
      )
    },
  },
}
</script>

<style lang="scss">
.LKRoadmapsFeedCardFiles {
  &__file-name {
    margin-right: 8px;
    word-break: break-all;
  }

  &__icon-close {
    display: inline-block !important;
    transform: scale(0.75);
  }
}
</style>
